import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Tag-pickers voor gelegenheden + ontvangers (cadeau-vinder).
 * Props: { occasions, recipients, onChange }
 */
export default function GiftTagPicker({ occasions = [], recipients = [], onChange }) {
    const [taxonomy, setTaxonomy] = useState({ occasions: [], recipients: [] });
    const [occ, setOcc] = useState(occasions);
    const [rec, setRec] = useState(recipients);

    useEffect(() => {
        api.get("/gift-finder/taxonomy").then(({ data }) => setTaxonomy(data)).catch(() => {});
    }, []);

    useEffect(() => { setOcc(occasions); }, [occasions]);
    useEffect(() => { setRec(recipients); }, [recipients]);

    const toggle = (key, val) => {
        const list = key === "occ" ? occ : rec;
        const setter = key === "occ" ? setOcc : setRec;
        const next = list.includes(val) ? list.filter(x => x !== val) : [...list, val];
        setter(next);
        onChange({ occasions: key === "occ" ? next : occ, recipients: key === "rec" ? next : rec });
    };

    return (
        <div className="space-y-3" data-testid="gift-tag-picker">
            <div>
                <p className="label-tiny mb-1.5">Gelegenheden</p>
                <div className="flex flex-wrap gap-1">
                    {taxonomy.occasions.map(o => (
                        <button key={o.id} type="button"
                            data-testid={`tag-occ-${o.id}`}
                            onClick={() => toggle("occ", o.id)}
                            className={`px-2 py-1 text-[10px] border transition-all ${occ.includes(o.id) ? "bg-rose-600 text-white border-rose-600" : "bg-white border-zinc-200 hover:border-rose-400"}`}>
                            {o.icon} {o.label}
                        </button>
                    ))}
                </div>
            </div>
            <div>
                <p className="label-tiny mb-1.5">Ontvangers</p>
                <div className="flex flex-wrap gap-1">
                    {taxonomy.recipients.map(r => (
                        <button key={r.id} type="button"
                            data-testid={`tag-rec-${r.id}`}
                            onClick={() => toggle("rec", r.id)}
                            className={`px-2 py-1 text-[10px] border transition-all ${rec.includes(r.id) ? "bg-zinc-950 text-white border-zinc-950" : "bg-white border-zinc-200 hover:border-zinc-700"}`}>
                            {r.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
